import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import callToActionBg from "../assests/callToActionBg.png";
import callToActionProduct from "../assests/callToActionProduct.png";

const CallToAction = () => {
  
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        zIndex: 1,
        marginBottom: { xs: "5x", md: "70px" },
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          width: "100%",
          display:"flex",
        }}
      >
        <Box  
        sx={{
          position: "relative",
          width: "100%",
          height: { sm: "auto", md: "283px" },
          backgroundImage: `url(${callToActionBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: {xs:"block", sm:"flex",md:"flex",lg:"flex"},
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: "row",
          textAlign: "left",
          borderRadius: "16px",
          padding: {xs:"20px 20px 0", sm:"20px", md:"20px 20px 0", lg:"20px 20px 0"},
        }}
        >
        <Box sx={{
          textAlign:{xs:"center", sm:"left", md:"left", lg:"left"},
        }}>
          <Typography
            variant="h6"
            sx={{
              fontFamily: `"Lato", sans-serif`,
              fontWeight: 400,
              lineHeight: { sm: "20px", md: "24px" },
              fontSize: { sm: "12px", md: "12px", lg: "12px" },
              color: "white",
            }}
          >
            Medical Series
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontFamily: `"Quicksand", sans-serif`,
              fontWeight: 700,
              lineHeight: {xs:"28px", sm: "30px", md:"38px", lg: "48px" },
              fontSize: { xs:"26px", sm: "24px", md: "28px", lg: "40px" },
              color: "white",
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              mb:{xs: 1, sm: 2, md:2, lg:2},
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            Stay home & get your Favorite
            <br />
            Medical Items from our shop
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontFamily: `"Quicksand", sans-serif`,
              fontWeight: 400,
              lineHeight: { sm: "11px", md: "11px" },
              fontSize: { sm: "16px", md: "18px", lg: "18px" },
              color: "white",
            }}
          >
            Starting from $190
          </Typography>
          <Button
            variant="contained"
            component={Link}
            to="/shop"
            sx={{
              marginTop: 2,
              backgroundColor: "#008BFF",
              width: "106.03px",
              height: "39.59px",
              borderRadius: "4px",
              color: "#fff",
              fontFamily: `"Quicksand", sans-serif`,
              fontWeight: 700,
              lineHeight: "21.6px",
              fontSize: { xs: "12px", md: "12px", lg: "12px" },
              textTransform: "capitalize",
              letterSpacing: "0.5px",
            }}
          >
            Shop Now
          </Button>
        </Box>
        <Box sx={{
          width:{xs:"100%",sm:"50%",md:"50%",lg:"50%"},
          height:{xs:"auto",sm:"100%",md:"100%",lg:"100%"},
          '& img':{
            width:'100%',
            height:"100%",
            objectFit:"contain",
          }
        }}>
          <img src={callToActionProduct} alt="product-image" />
        </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CallToAction;
